import React, { useEffect, useContext, useState } from "react"

import HomeMade from "../assets/svg/logos/homemade.svg"
import Express from "../assets/svg/logos/spark-express.svg"
import FoodBasket from "../assets/svg/logos/food-basket.svg"
import Sparkle247 from "../assets/svg/logos/sparkle-24-7.svg"
import Fresh from "../assets/svg/logos/fresh.svg"
import Electronics from "../assets/svg/logos/electronics.svg"

import Bills from "../assets/svg/logos/bills.svg"
import Load from "../assets/svg/logos/load.svg"
import Voucher from "../assets/svg/logos/voucher.svg"

import SparkOnAir from "../components/SparkOnAir"

import Spark from "../assets/svg/Mascot_Stand_Black_Stroke.svg"
import bayadDirectLogo from "../assets/svg/bayaddirect.jpg"
import sparkleAirBanner from "../assets/images/spark_on_air_landscape.png"
import HelpIcon from "@mui/icons-material/Help"
import TipsModal from "./TipsModal"

import PoweredByPldt from "../components/PoweredByPldt"
import PhoneTextfield from "../components/Textfields/PhoneTextfield"

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Grid from "@material-ui/core/Grid"
import { Link, navigate } from "gatsby"
import Container from "@material-ui/core/Container"
import { makeStyles } from "@material-ui/core/styles"
import { LazyLoadImage } from "react-lazy-load-image-component"
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import SecureLS from "secure-ls"
import { Form, Formik } from "formik"
import trimObjValues from "../helpers/trimobjectvalues"

import "../assets/css/masterindexpage.css"
import "../assets/scss/IndexPage.scss"
import "../assets/css/layout.css"

import Promotions from "./Promotions/Promotions"
import InputBase from "@material-ui/core/InputBase"

import VortexBottomGradient from "./BottomGradient"

import NeedHelp from "./NeedHelp"

import { GlobalStateSearchResult } from "./Homemade/SearchPage/state/SearchPageState"

import UAParser from "ua-parser-js"

import "../assets/css/addToHome.css"
// import { searchProducts } from '../api/public/search'

import { LoginState, PlatformVariables, StoreStatus, UserStatus } from "./globalstates"
import "animate.css"
import { Button, Stack, Typography } from "@mui/material"
import VortexServices from "./Vortex/components/VortexServices"
import FacebookDialog from "./Dialogs/FacebookDialog"
import InstallOptionDialog from "./Dialogs/InstallOptionDialog"
import { Box } from "@mui/system"
import { updateVortexByRefId } from "../api/public/vortex/transaction_db"
import Bottom from "./Homemade/BottomNavigator"
import LoginPage from "./LoginPage"
// import { sentryCatchException } from "../services/sentry/sentry"

// import TestAdd from "./Homemade/ShopPage/testAdd"
import { API } from "../api/api-config"
import useLoggedUser from "../custom-hooks/useLoggedUser"
import { getUserById } from "../api/public/user"
import BlockPrompt from "./Prompts/BlockPrompt"
import StoreBlockPrompt from "../components/Prompts/StoreBlockPrompt"
import useDiscordHelp from "./HelpCenter/hook-components/useDiscordHelp"


const filter = createFilterOptions();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginLeft: "0em",
    width: "100%",
  },
  control: {
    padding: theme.spacing(2),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    background: "white",
  },
  font: {
    fontFamily: "visby",
    position: "absolute",
    fontWeight: "bold",
    paddingTop: "2.6rem",
    fontSize: "13px",
    paddingLeft: ".1rem",
  },
}))

let parser = new UAParser()
let browser = parser.getBrowser()

const MasterIndexPage = () => {
  const ls = new SecureLS({ encodingType: "aes" })
  const classes = useStyles()

  //   const [userAgent, setUserAgent] = useState('')
  //   const [isAndroid, setIsAndroid] = useState(false)
  //   const [isApple, setIsApple] = useState(false)
  //   const [isWindows, setIsWindows] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [customerList, setCustomerList] = useState([])

  const [searchResults, setsearchResults] = useContext(GlobalStateSearchResult)

  const [isLoggin, setisLoggin] = useContext(LoginState)

  const [userStatus, setUserStatus] = useContext(UserStatus)

  const [storeStatus, setstoreStatus] = useContext(StoreStatus)

  const [platformVariables, setPlatformVariables] = useContext(PlatformVariables)

  const [cashier, setcashier] = useState(false)

  const [open, setOpen] = useState(false)

  const [customerUser, setCustomerUser] = useState(ls.get('currentCustomer'))

  const [messengerOpen, setMessengerOpen] = useState(false)

  const [value, setValue] = useState(null);

  const [openCustomer, toggleOpenCustomer] = useState(false);

  const { getUser, isLoggedIn } = useLoggedUser()

  const { showDiscordHelp, closeDiscordHelp, DiscordHelpDialog } = useDiscordHelp()

  const getCurrentCashierStatus = async () => {
    try {
      let { userId } = getUser()

      let result = await getUserById(userId)

      setUserStatus(result?.status)

      setstoreStatus(result?.store?.status)

    } catch (error) {
      alert(error)
    }
  }

  const handleClose = () => {
    setDialogValue({
      name: '',
      email: '',
      phone: '',
    });

    toggleOpenCustomer(false);
  };

  const [dialogValue, setDialogValue] = useState({
    name: '',
    email: '',
    phone: '',
  });

  const handleSubmit = async (event) => {
    event.preventDefault();

    let body = dialogValue
    if (body.email === "" || body.email === '')
      body.email = "n/a"

    let response = await fetch(`${API}/customer/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => {

        return response
      })
      .catch((err) => {

        return err
      })

    let jsonData = await response.json()
    console.log(jsonData)

    if (jsonData.error) {
      alert(jsonData.error)
    } else {

      setCustomerUser(jsonData.data);
      ls.set('currentCustomer', jsonData.data)

      setValue({
        name: dialogValue.name,
        email: dialogValue.email,
        phone: dialogValue.phone,
      });

      handleClose();
    }


  };

  useEffect(() => {
    let isLogin = isLoggedIn()

    let user = getUser()

    if (isLogin) {
      setcashier(user)
      setisLoggin(isLogin)
      getCurrentCashierStatus()
    }

  }, [])

  let browserName = browser.name
  //

  useEffect(() => {
    if (browserName.includes("Facebook")) {
      window.location.replace(`${window.location.href}/#fromMessenger`)
      setOpen(true)
    }
  }, [])

  let url = window.location.href

  useEffect(async () => {
    let response = await fetch(`${API}/customer/list/all`, {
      method: "GET",

      headers: {
        Accept: "application/json",
      },
    })

    let jsonData = await response.json()
    setCustomerList(jsonData)
  }, [value])

  useEffect(() => {
    if (url.includes("#fromMessenger")) {
      setMessengerOpen(true)
    }
  }, [])




  return (
    <>
      {!isLoggin && <LoginPage />}
      {storeStatus === 0 &&
        <StoreBlockPrompt />
      }
      {userStatus === 0 && (
        <BlockPrompt />
      )
      }
      {isLoggin && !open && userStatus === 1 && storeStatus === 1 ? (
        <div className="page ">
          <Container component="main" maxWidth="xs" className="page">
            <TipsModal />
            {/* <NeedHelp /> */}
            {messengerOpen ? <InstallOptionDialog /> : ''}
            <div className="heading">
              <div className="heading-bg">
                <div className="heading-greetings">
                  <div>
                    {/* <img
                      className="heading-logo" //animate__bounceIn
                      src={bayadDirectLogo}
                      alt="bayadDirectLogo"
                    /> */}

                    <Box sx={{ height: "10em" }} />
                  </div>
                  {/* <div>
                    <div className="heading-text animate__bounceIn">
                      <h1 className="heading-header">Sparkling Day, Juan!</h1>
                      What would you like to do for today?
                    </div>
                  </div> */}
                </div>
                <div className="heading-search-container">
                  {/* <div className="heading-search-shape">
                    <InputBase
                      disabled={true}
                      style={{
                        width: "100%",
                        fontFamily: "montserrat",
                        fontSize: "1em",
                        fontWeight: "500",
                        color: "#6b6b6b",
                        paddingLeft: "0.3em",
                        zIndex: 999,
                      }}
                      placeholder="Search for products here"
                      onClick={() => {
                        navigate("/search")
                      }}
                      // onKeyPress={(e) => {
                      //   // alert(e.key)

                      //   if (e.key === 'Enter') {
                      //     navigate('/search')
                      //   }
                      // }}
                    />
                  </div> */}
                </div>
              </div>
            </div>
            <Box sx={{ height: 10 }} />
            <Stack direction={"row"} justifyContent={"center"}>
              <Button onClick={showDiscordHelp}>Report issue / need help?</Button>
            </Stack>
            {/* Services Tiles */}
            {/* <div
              className="menu"
              style={{ overflowX: "hidden", overflowY: "hidden" }}
            >
              <Grid container spacing={4} className={classes.root}>
                <Grid item xs={4}>
                  <Link to="/food">
                    <img src={HomeMade} height="100px" alt="Home" />
                  </Link>
                  <div className="menu--text">Homemade</div>
                </Grid>
                <Grid item xs={4}>
                  <Link to="/express">
                    <img src={Express} height="100px" alt="Express" />
                  </Link>
                  <div className="menu--text">Express Delivery</div>
                </Grid>
                <Grid item xs={4} style={{ opacity: "0.5" }}>
                  <Link>
                    
                    <img src={FoodBasket} height="100px" alt="Express" />
                  </Link>
                  <div className="menu--text">Food Basket</div>
                </Grid>
              </Grid>
              <Grid container spacing={4} className={classes.root}>
                <Grid item xs={4} style={{ opacity: "0.5" }}>
                  <Link>
                    <img src={Sparkle247} height="100px" alt="Sparkle 24/7" />
                  </Link>
                  <div className="menu--text">Sparkle 24/7</div>
                </Grid>
                <Grid item xs={4} style={{ opacity: "0.5" }}>
                  <Link>
                    <img src={Fresh} height="100px" alt="Fresh" />
                  </Link>
                  <div className="menu--text">Fresh</div>
                </Grid>
                <Grid item xs={4} style={{ opacity: "0.5" }}>
                  <Link>
                    <img src={Electronics} height="100px" alt="Electronics" />
                  </Link>
                  <div className="menu--text">Electronics</div>
                </Grid>
              </Grid>
            </div> */}
            {/* Promotion banners */}
            {/* <PoweredByPldt /> */}

            <Stack m={3} direction={"row"} justifyContent={"right"}>
              <Button
                variant="outlined"
                onClick={() => {
                  navigate("/account")
                }}
              >
                Cashier: {cashier.name}
              </Button>
            </Stack>

            {!customerUser &&
              <>
                {/* <Stack m={3} direction={"column"} justifyContent={"right"}  sx={{marginTop: "5em"}}>
                  <Button
                    variant="contained"
                    fullWidth
                    size="large"
                    color="primary"
                      onClick={() => {
                        // navigate("/account")
                      }}
                    >
                      NEW CUSTOMER
                    </Button>
                    
              </Stack> */}

                <Stack m={3} direction={"row"} justifyContent={"center"}  >
                  <Autocomplete
                    id="customer-field"
                    freeSolo
                    options={customerList} //.map((option) => option)
                    autoHighlight
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    getOptionLabel={(option) => {
                      // e.g value selected with enter, right from the input
                      if (typeof option === 'string') {
                        return option;
                      }
                      if (option.inputValue) {
                        return option.inputValue;
                      }
                      return `${option.name} ${option.email} ${option.phone}`;
                    }}
                    renderInput={(params) => <TextField {...params} label="Customer Name/Phone/Email" />}
                    renderOption={(props, option) => <li {...props}>{option.name} {option.email} {option.phone}</li>}
                    sx={{ width: 300 }}
                    // onChange={(e)=> {
                    //   setCustomerUser(e.target.innerText)
                    //   console.log(e.target.innerText)
                    // }}
                    onChange={(event, newValue) => {
                      if (typeof newValue === 'string') {
                        // timeout to avoid instant validation of the dialog's form.
                        setTimeout(() => {
                          toggleOpenCustomer(true);
                          setDialogValue({
                            name: newValue,
                            phone: '',
                            email: '',
                          });
                        });
                      } else if (newValue && newValue.inputValue) {
                        toggleOpenCustomer(true);
                        setDialogValue({
                          name: newValue.inputValue,
                          phone: '',
                          email: '',
                        });
                      } else {
                        setCustomerUser(newValue);
                        ls.set('currentCustomer', newValue)
                        // setValue(newValue);
                      }

                    }}

                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      if (params.inputValue !== '') {
                        filtered.push({
                          inputValue: params.inputValue,
                          name: `Add "${params.inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                  />

                  <Dialog open={openCustomer} onClose={handleClose}>
                    <Formik
                      initialValues={{
                        name: dialogValue.name
                      }}
                      onSubmit={async (data) => {
                        try {
                          console.log(data)

                          let response = await fetch(`${API}/customer/`, {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify(trimObjValues(data)),
                          })
                            .then((response) => {

                              return response
                            })
                            .catch((err) => {

                              return err
                            })

                          let jsonData = await response.json()
                          console.log(jsonData)

                          if (jsonData.error) {
                            alert(jsonData.error)
                          } else {

                            setCustomerUser(jsonData.data);
                            ls.set('currentCustomer', jsonData.data)

                            setValue({
                              name: dialogValue.name,
                              email: dialogValue.email,
                              phone: dialogValue.phone,
                            });

                            handleClose();

                          }
                        } catch (error) {
                          alert("err on submit new customer")
                        }
                      }}
                    >
                      {({ handleChange, values, errors }) => {
                        return (
                          <Form>
                            <DialogTitle>Add a new Customer</DialogTitle>
                            <DialogContent>
                              <DialogContentText>
                                Can't see the customer in our list? Please, add it!
                              </DialogContentText>
                              <Stack spacing={2}>
                                <TextField
                                  autoFocus
                                  margin="dense"
                                  id="name"
                                  value={values.name}
                                  onChange={handleChange}
                                  label="name"
                                  type="text"
                                  required
                                  variant="standard"
                                />
                                <TextField
                                  margin="dense"
                                  id="email"
                                  value={values.email}
                                  onChange={handleChange}
                                  label="email"
                                  type="email"
                                  variant="standard"
                                />
                                <PhoneTextfield
                                  name={"phone"}
                                  label={"phone"}
                                  countryCodeIndex={971}
                                  placeholder={"phone number"}
                                />

                              </Stack>
                              {/* <TextField
                          margin="dense"
                          id="name"
                          value={dialogValue.phone}
                          onChange={(event) =>
                            setDialogValue({
                              ...dialogValue,
                              phone: event.target.value,
                            })
                          }
                          label="phone"
                          required
                          type="number"
                          variant="standard"
                        /> */}
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleClose}>Cancel</Button>
                              <Button type="submit">Add</Button>
                            </DialogActions>
                          </Form>
                        )
                      }}
                    </Formik>
                  </Dialog>
                  {/* <Button
                    variant="contained"
                    size="small"
                    sx={{width: 50, height: 50, marginTop: "1.5em", marginLeft: 3}}
                    
                      onClick={() => {
                        // navigate("/account")
                      }}
                    >
                      QR
                    </Button> */}
                </Stack>
              </>
            }
            <Box sx={{ height: "3em" }} />
            {/* <Button
              onClick={async () => {
                let updateObj = {
                  paymongoRefundResourceID: "TEST",
                }

                return await updateVortexByRefId({
                  refId: "TEST",
                  data: updateObj,
                })
              }}
            >
              Throw Error
            </Button> */}
            {customerUser &&
              <>
                <Stack m={3} direction={"row"} justifyContent={"center"}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      // navigate("/account")
                      setCustomerUser('')
                      ls.set('currentCustomer', '')
                    }}
                  >
                    Customer: {customerUser.name} {customerUser.email} {customerUser.phone}
                  </Button>

                </Stack>

                <Grid container spacing={4} className={classes.root}>
                  {/* style={{ opacity: "0.5" }} */}
                  <Grid item xs={4}
                    style={{
                      display: platformVariables.enableBills ? "" : "none"
                    }}>
                    <Link to="/vortexbillspayment">
                      <img src={Bills} height="100px" alt="Home" />
                    </Link>
                    <div className="menu--text">Bills</div>
                  </Grid>
                  <Grid item xs={4}
                    style={{
                      display: platformVariables.enableLoad ? "" : "none"
                    }}>
                    {/* <Link > */}
                    {/* to="/vortextopup/electronic_load" */}
                    <Link role={"vortex-topup"} to="/vortextopup/electronic_load">
                      <img src={Load} height="100px" alt="Express" />
                    </Link>
                    <div className="menu--text">Load</div>
                  </Grid>
                  <Grid item xs={4}
                    style={{
                      display: platformVariables.enableGift ? "" : "none"
                    }}
                  >
                    <Link to="/vortexvoucher">
                      <img src={Voucher} height="100px" alt="Express" />
                    </Link>
                    <div className="menu--text">Vouchers</div>
                  </Grid>
                </Grid>
                <Stack m={3} direction={"row"} justifyContent={"center"}>
                  <Button
                    onClick={() => {
                      navigate("/vortextransactionscustomer")
                    }}
                  >
                    View transactions
                  </Button>
                </Stack>

              </>}

            {/* <Button
          onClick={() => {
            showPaymentForm()
          }}
        >
          PAYMONGO TEST
        </Button> */}
            {/* <PaymongoPaymentDialog calculatedTotalAmountToPay={1000} /> */}

            {/* <div
              style={{
                fontFamily: "montserrat",
                marginTop: "1em",
                marginBottom: "1em",
                textAlign: "center",
                fontWeight: "500",
              }}
            >
              Offers you may like
            </div>
            <SparkOnAir /> */}
            <div
              className="PromotionBanners"
              style={{ overflowX: "hidden", height: "300px" }}
            >
              {/* <Promotions /> */}
            </div>
            <Bottom
            // value={homeMadeBottomNavigationIndex}
            // onChange={(event, newValue) => {
            //   sethomeMadeBottomNavigationIndex(newValue)
            // }}
            />
            {/* <VortexBottomGradient /> */}
            <Box sx={{ height: "10em" }} />
            <DiscordHelpDialog />
          </Container>
        </div>
      ) : (
        // <FacebookDialog permitted={open} />
        <></>
      )}
    </>
  )
}

export default MasterIndexPage
